type AvatarLightboxProps = {
  src?: string
  alt?: string
  open: boolean
  onClose: () => void
  actionLabel?: string
  onAction?: () => void
}

export default function AvatarLightbox({
  src,
  alt = "Profile photo",
  open,
  onClose,
  actionLabel,
  onAction,
}: AvatarLightboxProps) {
  if (!open || !src) return null

  return (
    <div className="fixed inset-0 z-[140] flex items-center justify-center bg-black/90 p-4" onClick={onClose}>
      <button type="button" className="absolute right-4 top-4 text-sm text-[#A8A8A8]" onClick={onClose}>
        Close
      </button>
      <div className="flex max-h-[90vh] w-full max-w-lg flex-col items-center" onClick={(event) => event.stopPropagation()}>
        <img src={src} alt={alt} className="max-h-[78vh] w-full rounded-2xl object-contain" />
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="mt-4 rounded-full bg-[#00C805] px-4 py-2 text-sm font-semibold text-black"
          >
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  )
}
